import { useQuery } from 'react-query';
import { dsoProductService } from 'services';
import { ServerStateKeysEnum } from '../../constants';

/**
 * Custom hook to fetch DSO product search data
 * Fetches all products once and caches them with infinite stale time
 * Client-side filtering should be performed on the returned data
 */
export const useDsoProductSearch = () => {
  return useQuery(
    `${ServerStateKeysEnum.dsoProductSearch}`,
    () => {
      return dsoProductService.getProductSearch();
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );
};
